/*====================================================
	BLOCK: Cardlist
====================================================*/
( function( $ ) {
	$('.card-collection .btn').hover(
		function() {
			$(this).closest('.card-collection').find('.bg-image').addClass('scale-hover-img');
		},
		function() {
			$(this).closest('.card-collection').find('.bg-image').removeClass('scale-hover-img');
		}
	);
})( jQuery );

/*====================================================
	Cardlist Slider
====================================================*/
const selector_cardlist = 'js__slider-cardlist';

const elements_cardlist = document.querySelectorAll(
	`.${selector_cardlist}`
);

if (elements_cardlist !== null) {
	for (const element of elements_cardlist) {
		buildSwiperCardlist(element);
	}
}

function buildSwiperCardlist(swiperElement) {
	const sliderIdentifier = swiperElement.dataset.swiperId;
	return new Swiper(`#swiper-${sliderIdentifier}`, {
		slidesPerView: 1.1,
		centeredSlides: true,
		spaceBetween: 15,
		loop: true,
		breakpoints: {
			450: {
				slidesPerView: 1.3,
				spaceBetween: 20,
			},
			550: {
				slidesPerView: 1.5,
				spaceBetween: 30,
			},
			650: {
				slidesPerView: 1.7,
			},
			800: {
				slidesPerView: 1.9,
			},
			1024: {
				slidesPerView: 3,
				centeredSlides: false,
				loop: false,
			},
		},
	});
}